import { Controller } from "@hotwired/stimulus"
import { Sortable } from 'sortablejs'

// Connects to data-controller="data-export-fields"
export default class extends Controller {
  static targets = ["container", "template"]
  static values = {
    availableFields: Array
  }

  connect() {
    this.initializeSortable()
    this.updateFieldNumbers()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initializeSortable() {
    this.sortable = Sortable.create(this.containerTarget, {
      handle: '.drag-handle',
      animation: 150,
      onEnd: () => {
        this.updateFieldNumbers()
        this.updateFieldIndexes()
      }
    })
  }

  addField(event) {
    event.preventDefault()
    
    const template = this.templateTarget.content.cloneNode(true)
    const fieldRow = template.querySelector('.export-field-row')
    
    // Set unique index for this field
    const index = Date.now()
    this.updateFieldRowIndexes(fieldRow, index)
    
    this.containerTarget.appendChild(fieldRow)
    this.updateFieldNumbers()
    this.updateFieldIndexes()
  }

  removeField(event) {
    event.preventDefault()
    const fieldRow = event.target.closest('.export-field-row')
    fieldRow.remove()
    this.updateFieldNumbers()
    this.updateFieldIndexes()
  }

  updateFieldNumbers() {
    const rows = this.containerTarget.querySelectorAll('.export-field-row')
    rows.forEach((row, index) => {
      const numberSpan = row.querySelector('.export-field-number')
      if (numberSpan) {
        numberSpan.textContent = index + 1
      }
    })
  }

  updateFieldIndexes() {
    // Update all field array indices to match current DOM order
    // This ensures Rails receives the fields in the correct order as a hash with sequential keys
    const rows = this.containerTarget.querySelectorAll('.export-field-row')
    rows.forEach((row, index) => {
      this.updateFieldRowIndexes(row, index)
    })
  }

  updateFieldRowIndexes(fieldRow, index) {
    // Update all input names and IDs with the new index
    const inputs = fieldRow.querySelectorAll('input, select')
    inputs.forEach(input => {
      if (input.name) {
        input.name = input.name.replace(/\[selected_fields\]\[\d+\]/, `[selected_fields][${index}]`)
      }
      if (input.id) {
        input.id = input.id.replace(/_selected_fields_\d+_/, `_selected_fields_${index}_`)
      }
    })
  }

  fieldChanged(event) {
    const select = event.target
    const fieldRow = select.closest('.export-field-row')
    const outputNameInput = fieldRow.querySelector('.output-name-input')
    
    // Auto-populate output name with selected field value if it's empty
    if (select.value && !outputNameInput.value) {
      const selectedOption = select.options[select.selectedIndex]
      outputNameInput.value = selectedOption.text
    }
  }
}

